import React from 'react';
import PropTypes from 'prop-types';

export default class Form extends React.Component {
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        return (
            <form className={`c-form ${this.props.className || ''}`}>
                {this.props.children}
            </form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Form/index.js